import { createRouter, createWebHistory } from 'vue-router'
import IncomingView from '@/views/IncomingView.vue'
import LandingView from '@/views/LandingView.vue'
import EntryAView from '@/views/EntryAView.vue'
import EntryBView from '@/views/EntryBView.vue'
import ResumeView from '@/views/ResumeView.vue'
import EndView from '@/views/EndView.vue'
import ErrorView from '@/views/ErrorView.vue'
import UnsubView from '@/views/UnsubView.vue'
import TrackingOptoutView from '@/views/TrackingOptoutView.vue' // [TRACKING-CONSENT]
import ProductView from '@/views/ProductView.vue'
import { mainStore } from '@/stores/datas.js'
import PreviewEmail from '../views/PreviewEmail.vue'
import { getEnv } from '@/plugins/getEnv.js';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/incoming',
      name: 'incoming',
      component: IncomingView
    },
    {
      path: '/landing',
      name: 'landing',
      component: LandingView
    },
    {
      path: '/:campaignCode',
      name: 'acquisition',
      component: EntryAView
    },
    {
      path: '/:campaignCode',
      name: 'acquisition-purchase',
      component: EntryBView
    },
    {
      path: '/produits',
      name: 'product',
      component: ProductView,
    },
    {
      path: '/resume',
      name: 'resume',
      component: ResumeView
    },
    {
      path: '/end',
      name: 'end',
      component: EndView
    },
    {
      path: '/error',
      name: 'error',
      component: ErrorView
    },
    {
      path: '/preview',
      name: 'preview',
      component: PreviewEmail
    },
    {
      path: '/unsub',
      name: 'unsub',
      component: UnsubView
    },
    // [TRACKING-CONSENT] Retrait du consentement à la mesure d'ouverture (lien en bas des emails)
    {
      path: '/tracking-optout',
      name: 'tracking-optout',
      component: TrackingOptoutView
    },
  ]
})

router.beforeEach((to, from, next) => {
  const env = getEnv();
  const store = mainStore();
  window.scrollTo(0, 0);
  if (env === 'prod' && typeof fbq === 'function') {
    fbq('track', 'PageView')
  }

  // Liste des routes qui ne nécessitent pas de campaign
  const noCampaignRoutes = ['incoming', 'error', 'preview', 'tracking-optout']; // [TRACKING-CONSENT]

  // Liste des routes qui ne nécessitent pas de user
  const noUserRoutes = ['incoming', 'acquisition', 'landing', 'error', 'acquisition-purchase', 'preview', 'tracking-optout']; // [TRACKING-CONSENT]

  // Les gagnants wheel peuvent accéder aux pages produit/resume/end sans user
  const isWheelWinner = store.isWheelWinner && store.wheelWinner?.token;
  const wheelAllowedRoutes = ['product', 'resume', 'end'];

  if (
    (
      !noCampaignRoutes.includes(to.name) &&
      store.campaign === null
    ) ||
    (
      !noCampaignRoutes.includes(to.name) &&
      store.campaign?.template === null
    ) ||
    (
      !noUserRoutes.includes(to.name) &&
      !wheelAllowedRoutes.includes(to.name) &&
      store.user === null
    ) ||
    (
      !noUserRoutes.includes(to.name) &&
      wheelAllowedRoutes.includes(to.name) &&
      store.user === null &&
      !isWheelWinner
    )
  ) {
    next({ name: 'error' })
  } else {
    next()
  }
})

export default router
